<!-- Breadcrumb Section Start -->
<section class="breadcrumb-section pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <!-- <h2>Privacy Policy</h2> -->
                    <h2>
                        <li class="breadcrumb-item">
                            <a [routerLink]="['/']" routerLinkActive="router-link-active"><i
                  class="fa-solid fa-house"></i></a>
                        </li>
                        <li class="breadcrumb-item active">Help Center</li>
                    </h2>
                    <nav>
                        <ol class="breadcrumb mb-0">

                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Breadcrumb Section End -->
<!-- Breadcrumb Section Start -->
<section class="faq-breadcrumb helpcenter pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <h2>Help Center</h2>
                    <p>We are glad having you here looking for the answer. As our team hardly working on the product, feel free to ask any questions. We Believe only your feedback might move us forward.
                    </p>
                    <!-- <div class="faq-form-tag">
                        <div class="input-group">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            <input type="search" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com">
                            <div class="dropdown">
                                <button class="btn btn-md faq-dropdown-button dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown">All Product <i class="fa-solid fa-angle-down ms-2"></i></button>
                                <ul class="dropdown-menu faq-dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="#">Action</a></li>
                                    <li><a class="dropdown-item" href="#">Another action</a></li>
                                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                    <div class="helpcenter_btn">
                        <button (click)="closeAccount()" type="submit" class="btn btn-animation btn-md fw-bold">
                          <ng-container *ngIf="token; else showLogin">Close Account</ng-container>
                          <ng-template #showLogin>Login</ng-template>
                      </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Breadcrumb Section End -->
<hr>
<!-- Help Center Imgboxes Section Start -->
<section class="helpcenter_imgboxes">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-lg-12">
                <!-- <h2>Title goes to here</h2> -->
            </div>
            <div class="col-lg-3">
                <div class="helpcenter_imgbox">
                    <!-- <h5>Title gose to here</h5> -->
                    <img src="assets/images/help/Group 1437252981.png" alt>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="helpcenter_imgbox">
                    <!-- <h5>Title gose to here</h5> -->
                    <img src="assets/images/help/Group 1437252982.png" alt>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="helpcenter_imgbox">
                    <!-- <h5>Title gose to here</h5> -->
                    <img src="assets/images/help/Group 1437252983.png" alt>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="helpcenter_imgbox">
                    <!-- <h5>Title gose to here</h5> -->
                    <img src="assets/images/help/Group 1437252984.png" alt>
                </div>
            </div>
        </div>
    </div>
</section>
